module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-12.186be68d.png";